import { render } from "./WeeklyReviewPreview.vue?vue&type=template&id=42889f2c&scoped=true"
import script from "./WeeklyReviewPreview.vue?vue&type=script&lang=js"
export * from "./WeeklyReviewPreview.vue?vue&type=script&lang=js"

import "./WeeklyReviewPreview.vue?vue&type=style&index=0&id=42889f2c&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42889f2c"]])

export default __exports__